/**
 * crypto.randomUUID() is only available in secure contexts (HTTPS / localhost / file://).
 * Mobile dev over LAN HTTP (e.g. http://192.168.x.y:3000) is NOT secure, so randomUUID
 * is undefined and any call throws. crypto.getRandomValues IS available everywhere.
 *
 * RFC 4122 v4 layout: 8-4-4-4-12 hex with version=4 and variant=10xx in the right bits.
 */
export function randomUUID(): string {
  const g = globalThis as { crypto?: { randomUUID?: () => string; getRandomValues?: (buf: Uint8Array) => Uint8Array } };
  if (typeof g.crypto?.randomUUID === "function") {
    return g.crypto.randomUUID();
  }

  const buf = new Uint8Array(16);
  if (typeof g.crypto?.getRandomValues === "function") {
    g.crypto.getRandomValues(buf);
  } else {
    // Last-ditch fallback. Anywhere we care about (browsers, Node ≥ 19) has
    // getRandomValues, so this branch is essentially unreachable but keeps
    // the function total.
    for (let i = 0; i < buf.length; i++) buf[i] = Math.floor(Math.random() * 256);
  }
  buf[6] = (buf[6] & 0x0f) | 0x40;
  buf[8] = (buf[8] & 0x3f) | 0x80;

  const hex = Array.from(buf, (b) => b.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
}
